import { Action, createReducer, on } from '@ngrx/store';

import { ParticipantVerificationActions } from '../actions';
import { ParticipantVerificationState } from '../state';
import { RejoiningParticipant } from '../../models/rejoining-participant.model';

const reducer = createReducer(
  ParticipantVerificationState.initialState,
  on(
    ParticipantVerificationActions.GetIdVerifications,
    (state: ParticipantVerificationState.State) => ({
      ...state,
    })
  ),
  on(
    ParticipantVerificationActions.SetIdVerifications,
    (state: ParticipantVerificationState.State, { payload }) => ({
      ...state,
      idVerifications: payload,
    })
  ),
  on(
    ParticipantVerificationActions.ApproveParticipant,
    (state: ParticipantVerificationState.State, { payload }) => ({
      ...state,
      approvedPackageUserGuids: [...state.approvedPackageUserGuids, payload],
    })
  ),
  on(
    ParticipantVerificationActions.RejoiningParticipant,
    (state: ParticipantVerificationState.State, { packageUserGuid, deviceCode }) => ({
      ...state,
      rejoiningUsers: updateRejoiningUsersList(state.rejoiningUsers, packageUserGuid, deviceCode),
    })
  ),
  on(
    //TODO: find a common name.
    ParticipantVerificationActions.DenyRejoiningParticipant,
    ParticipantVerificationActions.ApproveRejoiningParticipant,
    (state: ParticipantVerificationState.State, { packageUserGuid, deviceCode }) => ({
      ...state,
      rejoiningUsers: state.rejoiningUsers.filter(
        (rejoinedUser) =>
          !(
            rejoinedUser.packageUserGuid === packageUserGuid &&
            rejoinedUser.deviceCode === deviceCode
          )
      ),
    })
  ),
  on(
    ParticipantVerificationActions.DenyParticipant,
    (state: ParticipantVerificationState.State) => ({
      ...state,
    })
  ),
  on(
    ParticipantVerificationActions.GetStatusSuccess,
    (state: ParticipantVerificationState.State, { payload }) => ({
      ...state,
      approvedPackageUserGuids: payload.approvedParticipants,
      rejoiningUsers: payload.rejoiningParticipants,
      allSignersApproved: payload.isComplete,
      isAllSignersApprovedInfoLoaded: true,
    })
  ),
  on(
    ParticipantVerificationActions.SetAllSignersApproved,
    (state: ParticipantVerificationState.State, { payload }) => ({
      ...state,
      allSignersApproved: payload.allSignersApproved,
      isAllSignersApprovedInfoLoaded: true,
    })
  ),
  on(
    ParticipantVerificationActions.ApproveParticipantSuccess,
    ParticipantVerificationActions.DenyRejoiningParticipantSuccess,
    (state: ParticipantVerificationState.State, { payload }) => ({
      ...state,
      allSignersApproved: payload.areAllParticipantsApproved,
      approvedPackageUserGuids: payload.approvedParticipants,
    })
  ),
  on(
    ParticipantVerificationActions.ParticipantApproved,
    (state: ParticipantVerificationState.State, { packageUserGuid }) => ({
      ...state,
      approvedPackageUserGuids: state.approvedPackageUserGuids.includes(packageUserGuid)
        ? state.approvedPackageUserGuids
        : [...state.approvedPackageUserGuids, packageUserGuid],
    })
  )
);

function updateRejoiningUsersList(
  currentRejoiningUsers: RejoiningParticipant[] | undefined,
  packageUserGuid: string,
  deviceCode: string
): RejoiningParticipant[] {
  const rejoiningListExcludingCurrentUser =
    currentRejoiningUsers?.filter(
      (u) => u.packageUserGuid.toLowerCase() !== packageUserGuid.toLowerCase()
    ) ?? [];

  return [...rejoiningListExcludingCurrentUser, { packageUserGuid, deviceCode }];
}

export function participantVerificationReducer(
  state: ParticipantVerificationState.State | undefined,
  action: Action
) {
  return reducer(state, action);
}
